////////////////////////////////////////////////////////////////// VUE PLUGINS
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    easing: "ease-out",
    // duration: 1000,
    // offset: -window.innerHeight / 2,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

import FancyBox from './plugins/fancy-box/fancybox'
Vue.use(FancyBox)

import VueMouseParallax from 'vue-mouse-parallax'
Vue.use(VueMouseParallax)

////////////////////////////////////////////////////////////////// GLOBAL VUE COMPONENTS
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('bg-image', BgImage);

import CountTo from 'vue-count-to'
Vue.component('count-to', CountTo);

////////////////////////////////////////////////////////////////// GLOBAL VUE DIRECTIVES
import ScrollReveal from './directives/scroll-reveal/scroll-reveal'
Vue.directive('scroll-reveal', ScrollReveal)

////////////////////////////////////////////////////////////////// APP
import {
    disableBodyScroll,
    enableBodyScroll,
    // clearAllBodyScrollLocks
} from 'body-scroll-lock';
import SideMenu from './components/side-menu/side-menu.vue'
import Slick from 'vue-slick'
// import CookiesMsg from './components/cookies-msg/cookies-msg.vue'
import CookiesAdv from './components/cookies-advanced/cookies-advanced.vue'
import ModalPopup from './components/modal-popup/modal-popup.vue'

import 'bootstrap/js/dist/dropdown'

new Vue({
    el: '#app',
    components: {
        ModalPopup,
        CookiesAdv,
        SideMenu,
        Slick
    },
    data() {
        return {
            pageScrolled: false,
            sideMenuOpen: false,
            showBtnToTop: false,
            viewportWidth: window.innerWidth,
            viewportLandscape: (window.innerWidth / window.innerHeight > 1) ? true : false
        }
    },
    methods: {
        onScroll($event) {
            this.pageScrolled = window.pageYOffset > 0;

            if (window.pageYOffset > 500) {
                this.showBtnToTop = true
            } else {
                this.showBtnToTop = false
            }
        },
        toggleSideMenu() {
            if (!this.sideMenuOpen) {
                disableBodyScroll(document.querySelector('.side-menu-links'), {
                    paddingRightElements: [document.body, document.querySelector('.header'), document.querySelector('#side-menu')],
                    reserveScrollBarGap: true,
                });
            } else {
                enableBodyScroll(document.querySelector('.side-menu-links'), {
                    reserveScrollBarGap: true
                });
            }
            this.sideMenuOpen = !this.sideMenuOpen;
        },
        handleResize() {
            this.viewportWidth = window.innerWidth
            this.viewportLandscape = (window.innerWidth / window.innerHeight > 1) ? true : false
        }
    },
    mounted() {
        if (window.location.hash) {
            var hash = window.location.hash;
            VueScrollTo.scrollTo(hash, 2500, {
                offset: -82,
                cancelable: false,
            })
        }
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;

        window.addEventListener('scroll', this.onScroll, {
            passive: true
        })

        window.addEventListener("resize", this.handleResize, {
            passive: true
        })
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
})